export type PartnerDocument = {
    name: string
    path: string
    timeCreated: string
    size: number
    contentType: string
}

export const PARTNER_CLAIM = 'partner' as const

export const PARTNER_ROUTES = {
    login: '/socios/login',
    documents: '/socios',
    changePassword: '/socios/cambiar-contrasena',
} as const

export const PARTNER_NOINDEX_PATHS = [
    PARTNER_ROUTES.login,
    PARTNER_ROUTES.documents,
    PARTNER_ROUTES.changePassword,
] as const
